import { createApi } from '@reduxjs/toolkit/query/react'
import { axiosBaseQuery } from '@/services/rtkQueryBaseQuery'

export const apiSlice = createApi({
  reducerPath: 'api',
  baseQuery: axiosBaseQuery(),
  tagTypes: [
    'DocumentLifecycle',
    'AccountLedger',
    'Accounting',
    'AccrualTemplate',
    'AccruedRevenue',
    'Admin',
    'AiApproval',
    'AiConversation',
    'AiUsage',
    'ApprovalNotification',
    'AssetCategory',
    'AssetLocation',
    'AuditTrail',
    'Auth',
    'AvailableUser',
    'Backup',
    'BackupSettings',
    'BankReconciliation',
    'BotAnalytics',
    'BotAutoReply',
    'BotChannel',
    'BotConversation',
    'BotTemplate',
    'Budget',
    'CashFlowClassifications',
    'CashWithdrawal',
    'ControlAccountReconciliation',
    'CostCenter',
    'CostCenterTree',
    'CompanyTaxProfile',
    'CustodyPayment',
    'Customer',
    'DashboardStats',
    'Defaults',
    'DepreciationSchedule',
    'DynamicReport',
    'Expense',
    'ExpenseCategory',
    'FiscalPeriod',
    'FixedAsset',
    'GLInquiry',
    'Hrm',
    'LIST',
    'Log',
    'ManualJournal',
    'Module',
    'Notification',
    'POS',
    'Payroll',
    'Permission',
    'PermissionGroup',
    'PersonalWithdrawal',
    'Plan',
    'PosCustomer',
    'PosDraft',
    'PosProduct',
    'PrepaidExpense',
    'Products',
    'Project',
    'PublicSettings',
    'Purchases',
    'Quotations',
    'Reports',
    'Role',
    'Sales',
    'SaleReturn',
    'Settings',
    'Supplier',
    'SystemHealth',
    'TaxBracket',
    'Tenant',
    'TenantStats',
    'TenantUser',
    'Transfers',
    'UnreadCount',
    'User',
    'UserStats',
    'Variance',
    'VatReturn',
    'VersionInfo',
    'Warehouse',
  ],
  endpoints: () => ({}),
})

